import type { SelectChangeEvent, Theme } from "@mui/material";
import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, useTheme } from "@mui/material";
import type { FC } from "react";
import { useMediaTags } from "../admin/dictionaries/useMediaTags";

function getStyles(value: string, selectedValues: string[], theme: Theme) {
  return {
    fontWeight: selectedValues.includes(value) ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,
  };
}

interface Props {
  readonly selectedValues: string[];
  readonly fullWidth?: boolean;
  readonly onSelectionChange: (values: string[]) => void;
}

const ImageTagsSelect: FC<Props> = ({ selectedValues, fullWidth, onSelectionChange }) => {
  const theme = useTheme();
  const { tags } = useMediaTags();

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value;
    onSelectionChange(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <FormControl fullWidth={fullWidth}>
      <InputLabel id="image-tag-select-label">Tagi</InputLabel>
      <Select
        labelId="image-tag-select-label"
        id="image-tag-select"
        multiple
        fullWidth={fullWidth}
        value={selectedValues}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" fullWidth={fullWidth} label="Tagi" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip key={value} label={value} />
            ))}
          </Box>
        )}
      >
        {tags.map(({ name }) => (
          <MenuItem key={name} value={name} style={getStyles(name, selectedValues, theme)}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ImageTagsSelect;
